goog.provide("shadow.js.shim.module$react_use$lib$component$UseKey");
goog.provide("module$shadow_js_shim_module$react_use$lib$component$UseKey");
shadow.js.shim.module$react_use$lib$component$UseKey = shadow.js.nativeProvides["react-use/lib/component/UseKey"] = shadow$bridge("react-use/lib/component/UseKey");
module$shadow_js_shim_module$react_use$lib$component$UseKey.default = shadow.js.shim.module$react_use$lib$component$UseKey;
